export const ADD_SQA_ERROR = {
  INVALID_FIRST_SEC_ANS: 'INVALID_FIRST_SEC_ANS',
  INVALID_SECOND_SEC_ANS: 'INVALID_SECOND_SEC_ANS',
  SEL_FIRST_SEC_QUESTION: 'SEL_FIRST_SEC_QUESTION',
  SEL_SECOND_SEC_QUESTION: 'SEL_SECOND_SEC_QUESTION',
  ANS_IN_USE: 'ANS_IN_USE',
  SEC_ANS_LESS_THAN_FOUR_CHAR: 'SEC_ANS_LESS_THAN_FOUR_CHAR',
  QUESTION_IN_USE: 'QUESTION_IN_USE'
};
